<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Attendance Maps</li>
      </ol>
    </div>
    <div class="attendance-nav">
      <div class="sub-left-inrgt">
        <div class="shiftdrop-menu-wrp">
          <span class="shift-opener text-capitalize">
            <i class="ico ico-fill-circle" :style="{color:roleColor}"></i>
            <span class="roleName"> Select job type</span>
          </span>
          <ul class="shiftdrop-list">
            <li style="background: rgb(152, 152, 152);">
              <i class="ico ico-fill-circle"></i>
              <span>All</span>
            </li>
            <li class="text-capitalize" v-for="(role,rolIndx) of selectedCompany.jobRoles" :key="rolIndx"
                @click="filterByJobType(role.id,role.color,role.name)">
              <span class="bg-role" :style="{'background':role.color}"></span>
              <i class="ico ico-fill-circle" v-bind:style="{ color: role.color !== null ? role.color : '',}"></i>
              <span>{{ role.name }}</span>
            </li>
          </ul>
        </div>
      </div>
          <div><input type="text" class="form-control" v-model="searchedName" placeholder="Search by name" @keyup="attendanceSearchByName"></div>
      <div class="sub-right ">
        <div class="ml-2">
          <date-picker
            v-model="dateFilter"
            type="date"
            lang="en"
            @change="filterAttendance($event)"
          ></date-picker>
        </div>
      </div>

    </div>
    <div class="attendance-report emp-map">
      <div class="emp-listing" style="width: 20% !important;">
        <div :class="[id === user.id ? 'active' : '', 'empl-info cursor-pointer']" v-for="(user,Windex) of users" :key="Windex" @click="filterUser(user.id)">
          <div class="avtar">
            <a href="javascript:void(0);" v-if="user.image !== ''">
              <img :src="$API_URL+'storage/'+user.image" @error="imageNotFound" alt="Profile image" width="50"
                   height="50">
            </a>
            <span v-if="user.image === ''" class="profile-name text-uppercase">{{ getNameIfNotImage(user.name) }}</span>
            <span v-show="user.image !== '' && imgNotFnd"
                  class="profile-name text-uppercase">{{ getNameIfNotImage(user.name) }}</span>
          </div>
          <div class="empl-descrip">
            <strong class="emp-name text-capitalize">
              <a href="javascript:void(0);">
                <strong class="emp-name text-capitalize" @click="setUserData(user)">{{ user.name }}</strong>
              </a>
            </strong>
            <div class="emp-designation">
              <span v-for="role of user.employeeJobType" :key="role.id">
                <i class="ico ico-fill-circle"
                   :style="{color:role.get_job_roles !== null? role.get_job_roles.color: ''}"></i>
                {{ role.get_job_roles.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="goolge-map">
        <div class="mapouter">
          <div class="gmap_canvas">
            <div id="map"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import collect from "collect.js";
import DatePicker from 'vue2-datepicker';

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      users: [],
      selectedCompany: this.$store.getters.getSelectedCompany,
      markers: [],
      map: null,
      allUsers: [],
      allAttendance: [],
      imgNotFnd : false,
      id: null,
      role: null,
      roleColor: "",
      filteredUsers: [],
      dateFilter: new Date(),
      attendance: [],
      attendanceCopy: [],
      selectedCompany: this.$store.getters.getSelectedCompany,
      searchedName:''
    }
  },

  created() {

  },
  mounted() {
    this.initMap();
    this.getEmployeesWithAttendance();
  },
  methods: {
    attendanceSearchByName(){
      this.attendance = this.attendanceCopy;
      collect().macro("whereLike", function (search) {
        var searched = new RegExp(search, "i");
        return this.filter((item) =>{
          //console.log(item,'search item')
          return searched.test(item.user_name);
        }
        );
      });
      this.attendance = collect(this.attendance)
        .whereLike(this.searchedName)
        .all();
        this.loadMarkers();
    },
    imageNotFound(event) {
      if (event.type === 'error') {
        $(event.target).remove();
        this.imgNotFnd = true;
      }
    },
    initMap() {
      let companyLatLong = (this.selectedCompany.locations)?this.selectedCompany.locations[0]:null;
      const myLatLng = {
        lat: (companyLatLong) ? parseFloat(companyLatLong.lat) : 31.5198893,
        lng: (companyLatLong) ? parseFloat(companyLatLong.lng) : 74.3508756
      };
      this.map = new google.maps.Map(document.getElementById("map"), {
        zoom: 17,
        center: myLatLng,
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [
              { visibility: "off" }
            ]
          }
        ]
      });
    },

    filterAttendance(event) {
      this.id = null;
      this.getEmployeesWithAttendance(this.dateFilter);
    },

    setUserData(user) {
      this.$store.commit('setEmployeeProfileId', user);
    },

    filterByJobType(id, color, name) {
      this.id = null;
      this.role = id;
      let tagNam = $('.roleName')[0];
      tagNam.innerText = name;
      this.roleColor = color;
      this.users = this.allUsers;
      this.attendance = this.allAttendance;
      this.users = this.users.filter((item) => {
        if (item.roleTypeIds.includes(id)) {
          this.filteredUsers.push(item.id);
          return item;
        }
      });

      this.attendance = this.attendance.filter((item) => {
        if (this.filteredUsers.includes(item.user_id)) {
          return item;
        }
      });
      this.loadMarkers();
    },

    filterUser(id) {
      this.id = id;
      this.attendance = this.allAttendance;
      this.attendance = this.attendance.filter((item) => {
        if (item.user_id === id) {
          return item;
        }
      });
      this.loadMarkers();
    },

    getNameIfNotImage(name) {
      return this.getNameFirstLetter(name);
    },

    getEmployeesWithAttendance(date = new Date()) {
      this.$axios({
        method: "get",
        params: {
          company_id: this.selectedCompany.id,
          date: this.dateFilter
        },
        url: this.$AttendanceMap,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status === 200) {
          this.users = res.data.result.user;
          this.allUsers = res.data.result.user;
          this.attendance = this.attendanceCopy = res.data.result.data;
         // console.log(this.attendance,'atteeeen')
          this.allAttendance = res.data.result.data;
          this.users.filter(user => {
            user['roleTypeIds'] = user.employeeJobType.map((role) =>
              role.get_job_roles !== null ? role.get_job_roles.id : null
            );
          });
        this.loadMarkers();
        }
      });
    },

    getAttendance(date = new Date()) {
      this.$axios({
        method: "get",
        params: {
          company_id: this.selectedCompany.id,
          date: date
        },
        url: this.$AttendanceMap,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status === 200) {
          this.allAttendance = res.data.result.data;
          this.attendance = res.data.result.data;
          if(this.role != null){
            this.attendance = this.attendance.filter((item) => {
              if (this.filteredUsers.includes(item.user_id)) {
                return item;
              }
            });
          }
        }
        this.loadMarkers();
      });
    },

    clearMarkers() {
      this.markers.forEach(function (marker) {
        marker.setMap(null);
      });
    },

    loadMarkers() {
      this.clearMarkers();
      var scope = this;
      const inImage = require('@/assets/images/in_unselected.svg');
      const inImageSelected = require('@/assets/images/in_selected.svg');
      const outImage = require('@/assets/images/out_unselected.svg');
      const outImageSelected = require('@/assets/images/out_selected.svg');
      this.attendance.forEach(function (user) {
        if(user.attendance.length > 0) {
          user.attendance.forEach(function (times) {
            if(times.in.latitude != null && times.in.longitude != null && times.in.time != null) {
              let myLatLng = {
                lat: parseFloat(times.in.latitude),
                lng: parseFloat(times.in.longitude)
              };
              let map = scope.map;
              let marker = new google.maps.Marker({
                position: myLatLng,
                map,
                icon: inImage,
                animation: google.maps.Animation.DROP
              });
              scope.markers.push(marker);
              const infoWindow = new google.maps.InfoWindow();
              marker.addListener("click", () => {
                marker.setIcon(inImageSelected);
                infoWindow.close();
                let text = '<div style="text-align: left !important;"><strong>'+times.user+'</strong><br>'+times.name+'<br>';
                text += '<strong>Punch In: </strong>'+times.in.time+'<br>';
                text += '<strong>Note: </strong>'+times.in.note+'<br>';
                text += '<strong>Start: </strong>'+times.start+'<br>';
                text += '<strong>End: </strong>'+times.end+'<br>';
                text += '</div>';
                infoWindow.setContent(text);
                infoWindow.open(marker.getMap(), marker);
              });
              google.maps.event.addListener(infoWindow,'closeclick',function(){
                marker.setIcon(inImage);
              });
            }
            if(times.out.latitude != null && times.out.longitude != null && times.out.time != null) {
              let myLatLng = {
                lat: parseFloat(times.out.latitude),
                lng: parseFloat(times.out.longitude)
              };
              let map = scope.map;
              let marker = new google.maps.Marker({
                position: myLatLng,
                map,
                icon: outImage,
                animation: google.maps.Animation.DROP
              });
              const infoWindow = new google.maps.InfoWindow();
              marker.addListener("click", () => {
                infoWindow.close();
                marker.setIcon(outImageSelected);
                let text = '<div style="text-align: left !important;"><strong>'+times.user+'</strong><br>'+times.name+'<br>';
                text += '<strong>Punch Out: </strong>'+times.out.time+'<br>';
                text += '<strong>Note: </strong>'+times.out.note+'<br>';
                text += '<strong>Start: </strong>'+times.start+'<br>';
                text += '<strong>End: </strong>'+times.end+'<br>';
                text += '</div>';
                infoWindow.setContent(text);
                infoWindow.open(marker.getMap(), marker);
              });
              google.maps.event.addListener(infoWindow,'closeclick',function(){
                marker.setIcon(outImage);
              });
              scope.markers.push(marker);
            }
          });
        }
      });
    }
  }
}
</script>
<style scoped>
#map {
  height: 100%;
}
.mapouter {
  position: relative;
  text-align: right;
  width: 100%;
  height: 527px;
}

.gmap_canvas {
  overflow: hidden;
  background: none !important;
  width: 100%;
  height: 527px;
}

.gmap_iframe {
  height: 527px !important;
}
</style>
